import { Tag, TagSize } from '@creditornot/cb-tag';

const localHostnames = ['localhost', '127.0.0.1'];

const isLocalhost = localHostnames.includes(window.location.hostname);

type Props = {
  size?: TagSize;
  className?: string;
};

export const DevIndicator = ({ size, className }: Props) => {
  if (isLocalhost || import.meta.env.VITE_APP_ENV !== 'development') return null;

  return (
    <Tag variant="blue" size={size} className={className}>
      Dev
    </Tag>
  );
};
